module.exports = __webpack_public_path__ + "static/media/01-home.c290c95e.png";